import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import withSignLayout from 'components/ui/withSignLayout';
import Logo from 'components/ui/Logo';
import EmailForm from 'components/signin/EmailForm';
import CodeForm from 'components/signin/CodeForm';

const SignIn = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState(null);

  return (
    <div className="container d-flex flex-column justify-content-center h-100 align-items-center">
      <div>
        <a href="https://youfy.com.br">
          <Logo width={150} />
        </a>
        <h2 className="mt-4 h2 fw-lighter">{t('signin.description')}</h2>
        <EmailForm show={!email} setEmail={setEmail} />
        <CodeForm email={email} setEmail={setEmail} />
      </div>
    </div>
  );
};

export default withSignLayout(SignIn);
